var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step2-container" },
    [
      _c(
        "div",
        {
          staticClass: "main-content-container no-scrollbar",
          on: { scroll: _vm.scrollToEnd }
        },
        [
          _c("div", { staticClass: "content-container" }, [
            !_vm.addonProducts || _vm.addonProducts.length == 0
              ? _c(
                  "ul",
                  { staticClass: "products-container no-scrollbar" },
                  _vm._l(12, function(n) {
                    return _c(
                      "li",
                      { key: n },
                      _vm._l(12, function(n) {
                        return _c("AddonProductSkeleton", { key: n })
                      }),
                      1
                    )
                  }),
                  0
                )
              : _c(
                  "ul",
                  { staticClass: "products-container no-scrollbar" },
                  [
                    _vm.nonFilteredProducts.length > 0
                      ? _c("p", { staticClass: "other-gifts" }, [
                          _vm._v(_vm._s(_vm.breadcrumbText))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.sortedProducts, function(addonProduct) {
                      return _c(
                        "li",
                        { key: addonProduct.id },
                        [
                          _c("AddonProductNew", {
                            attrs: {
                              product: addonProduct,
                              cartProducts: _vm.selectedAddonProducts,
                              addCopy: _vm.addCopy
                            },
                            on: {
                              loadmodal: function($event) {
                                return _vm.openModal($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.nonFilteredProducts.length > 0
                      ? _c("p", { staticClass: "other-gifts" }, [
                          _vm._v("All Other Gifts")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.nonFilteredProducts, function(addonProduct) {
                      return _c(
                        "li",
                        { key: addonProduct.id },
                        [
                          _c("AddonProductNew", {
                            attrs: {
                              product: addonProduct,
                              cartProducts: _vm.selectedAddonProducts,
                              addCopy: _vm.addCopy
                            },
                            on: {
                              loadmodal: function($event) {
                                return _vm.openModal($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.selectedAddonProducts.length > 0
        ? _c("SideCartMobile", {
            attrs: { cartProducts: _vm.selectedAddonProducts },
            on: {
              openmodal: function($event) {
                return _vm.openModal($event)
              },
              changepage: function($event) {
                return _vm.changePage($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AddonProductModalMobile", {
        attrs: {
          showModal: _vm.showModal,
          selectedAddon: _vm.currentSelectedAddon,
          addonProducts: _vm.modalProducts,
          cartProducts: _vm.selectedAddonProducts,
          recommendedProducts: _vm.modalRecommendedProducts
        },
        on: {
          closemodal: function($event) {
            return _vm.closeModal()
          },
          changeselectedaddon: function($event) {
            return _vm.openModal($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.showBrandableModal == true && _vm.currentSelectedAddon != null
        ? _c("BrandableProductModal", {
            attrs: {
              selectedAddon: _vm.currentSelectedAddon,
              addonProducts: _vm.modalProducts,
              cartProducts: _vm.selectedAddonProducts,
              recommendedProducts: _vm.modalRecommendedProducts
            },
            on: {
              closemodal: function($event) {
                return _vm.closeModal()
              },
              changeselectedaddon: function($event) {
                return _vm.openModal($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("FiltersMobile", {
            attrs: {
              isSticking: _vm.isSticking,
              filteredPreAddons: _vm.filteredPreProducts,
              filteredAddons: _vm.sortedProducts
            },
            on: {
              goall: _vm.goAll,
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sortIsShown
        ? _c("SortMobile", {
            attrs: { isSticking: _vm.isSticking },
            on: {
              closefilter: function($event) {
                return _vm.showSort()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }